import { useState } from 'react';

import { validators } from '@/shared/utils/validator';

export const useValidatePassword = () => {
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const validatePassword = (password: string) => {
    if (!password) {
      setPasswordError('');
      return;
    }

    const passwordValidation = validators.password(password);

    if (!passwordValidation.valid) {
      const errorMessage = passwordValidation.error.toLowerCase();
      setPasswordError(errorMessage);
      return;
    }
    setPasswordError('');
  };

  const validateConfirmPassword = (
    password: string,
    confirmedPassword: string,
  ) => {
    if (!confirmedPassword) {
      setConfirmPasswordError('');
      return;
    }

    const confirmPasswordValidation = validators.confirmPassword(
      password,
      confirmedPassword,
    );

    if (!confirmPasswordValidation.valid) {
      const errorMessage = confirmPasswordValidation.error.toLowerCase();
      setConfirmPasswordError(errorMessage);
      return;
    }
    setConfirmPasswordError('');
  };

  return {
    validatePassword,
    validateConfirmPassword,
    passwordError,
    confirmPasswordError,
  };
};
